<template>
  <span>
    <!--Chart canvas-->
    <div class="row my-5">
      <div class="col-lg-12">
        <!-- <div id="participant-result" style="height: 500px;"></div> -->
        <chart v-if="loaded" :chartdata="chartdata" :options="options" />
      </div>
    </div>
    <!--END: Chart canvas-->

    <div class="row">
      <div class="col-lg-12 pb-4">
        <h2 class="font-green">{{ trans('graph.filters') }}</h2>
      </div>
    </div>

    <!--filter-->
    <div class="row mb-5">
      <div class="col-lg-12">
        <div class="bg-gray-light p-5 border-bottom border-top mb-4">
          <div class="row mb-3">
            <div class="col-lg-4">
              <select-afiq
                v-model="gender.selected"
                :title="gender.title"
                :options="gender.options"
                :icon="gender.icon"
              ></select-afiq>
            </div>
            <div class="col-lg-4">
              <select-afiq
                v-model="marital.selected"
                :title="marital.title"
                :options="marital.options"
                :icon="marital.icon"
              ></select-afiq>
            </div>
            <div class="col-lg-4">
              <select-afiq
                v-model="ethnic.selected"
                :title="ethnic.title"
                :options="ethnic.options"
                :icon="ethnic.icon"
              ></select-afiq>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-lg-4">
              <select-afiq
                v-model="industry.selected"
                :title="industry.title"
                :options="industry.options"
                :icon="industry.icon"
              ></select-afiq>
            </div>
            <div class="col-lg-4">
              <select-afiq
                v-model="age.selected"
                :title="age.title"
                :options="age.options"
                :icon="age.icon"
              ></select-afiq>
            </div>

            <div class="col-lg-4">
              <select-afiq
                v-model="flag.selected"
                :title="flag.title"
                :options="flag.options"
                :icon="flag.icon"
              ></select-afiq>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-lg-4">
              <select-afiq
                v-model="programme.selected"
                :title="programme.title"
                :options="programme.options"
                :icon="programme.icon"
              ></select-afiq>
            </div>
            <div class="col-lg-4">
              <select-afiq
                v-model="state.selected"
                :title="state.title"
                :options="state.options"
                :icon="state.icon"
              ></select-afiq>
            </div>
            <!-- <div class="col-lg-4">
                            <select-afiq
                                v-model="date.selected"
                                :title="date.title"
                                :options="date.options"
                                :icon="date.icon"
                            ></select-afiq>
            </div>-->
          </div>
        </div>
      </div>
    </div>
    <!--END: filter-->
  </span>
</template>

<script>
export default {
  data() {
    return this.initialState();
  },
  mounted() {
    // this.loaded = false;
    // this.renderChart(this.dataset, this.options);
    this.loadIndustries();
  },
  watch: {
    "gender.selected": function (val) {
      this.loadData();
    },
    "marital.selected": function (val) {
      this.loadData();
    },
    "ethnic.selected": function (val) {
      this.loadData();
    },
    "industry.selected": function (val) {
      this.loadData();
    },
    "age.selected": function (val) {
      this.loadData();
    },
    "programme.selected": function (val) {
      this.loadSchedule();
    },
    "state.selected": function (val) {
      this.loadDate();
    },
    "flag.selected": function (val) {
      this.loadDate();
    },
  },
  methods: {
    async loadIndustries() {
      let loader = this.$loading.show();
      try {
        var routeQuestion = "";
        if (window.current_lang == "en") {
          routeQuestion = route("api.en.industries.index");
        } else {
          routeQuestion = route("api.ms.industries.index");
        }

        const [programmes, industries] = await Promise.all([
          axios.get(route("api.programmes.index")),
          axios.get(routeQuestion),
        ]);
        this.programme.options = programmes.data;
        this.industry.options = industries.data.data;
        loader.hide();
        this.loadData();
      } catch (e) {
        console.log(e);
        loader.hide();
        this.errorPopup(e.response.data.message);
      }
    },
    async loadDate() {
      let loader = this.$loading.show();
      this.date = this.initialState().date;
      try {
        const { data } = await axios.post(route("api.schedules.times"), {
          schedule_id: this.state.selected.id,
        });
        this.date.options = data;
        loader.hide();
        this.loadData();
      } catch (e) {
        loader.hide();
        console.log(e);
        this.errorPopup(e.response.data.message);
      }
    },
    async loadSchedule() {
      let loader = this.$loading.show();
      this.state = this.initialState().state;
      try {
        const { data } = await axios.get(
          route("api.states.programme", this.programme.selected.id)
        );
        this.state.options = data;
        loader.hide();
        this.loadData();
      } catch (e) {
        loader.hide();
        this.errorPopup(e.response.data.message);
      }
    },
    async loadData() {
      let loader = this.$loading.show();
      this.loaded = false;
      try {
        const { data } = await axios.post(route("api.participants.statistic"), {
          gender: this.gender.selected.id,
          marital_status: this.marital.selected.id,
          ethnic: this.ethnic.selected.id,
          industry: this.industry.selected.id,
          dob: this.age.selected.id,
          programme_id: this.programme.selected.id,
          state_id: this.state.selected.id,
          flag: this.flag.selected.id,
        });
        this.chartdata.datasets[0].data = data;
        this.loaded = true;
        loader.hide();
      } catch (e) {
        console.log(e);
        loader.hide();
        this.errorPopup(e.response.data.message);
      }
    },
    initialState() {
      return {
        flag: {
          selected: {
            id: null,
            name: null,
          },
          title: "Flag Cases",
          icon: "la-flag-o",
          options: [
            { id: null, name: "No" },
            { id: 1, name: "Yes" },
          ],
        },
        age: {
          selected: {
            id: null,
            name: null,
          },
          title: "Age Group",
          icon: "la-group",
          options: [
            { id: 18, name: "Under 18 years old" },
            { id: 30, name: "18 - 30 years old" },
            { id: 40, name: "31 - 40 years old" },
            { id: 50, name: "41 - 50 years old" },
            { id: 60, name: "51 - 60 years old" },
            { id: 70, name: "60 years old and above" },
          ],
        },
        date: {
          selected: {
            id: null,
            name: null,
          },
          title: "Date",
          icon: "la-calendar",
          options: [],
        },
        state: {
          selected: {
            id: null,
            name: null,
          },
          title: "State",
          icon: "la-map-marker",
          options: [],
        },
        programme: {
          selected: {
            id: null,
            name: null,
          },
          title: "Programme",
          icon: "la-file-text",
          options: [],
        },
        industry: {
          selected: {
            id: null,
            name: null,
          },
          title: "Industry",
          icon: "la-industry",
          options: [],
        },
        gender: {
          selected: {
            id: null,
            name: null,
          },
          title: "Gender",
          icon: "la-intersex",
          options: [
            { id: 1, name: "Male" },
            { id: 2, name: "Female" },
          ],
        },
        marital: {
          selected: {
            id: null,
            name: null,
          },
          title: "Marital Status",
          icon: "la-heart-o",
          options: [
            { id: 1, name: "Single" },
            { id: 2, name: "Married" },
            { id: 3, name: "Divorced" },
            { id: 4, name: "Widowed" },
          ],
        },
        ethnic: {
          selected: {
            id: null,
            name: null,
          },
          title: "Ethnicity",
          icon: "la-user",
          options: [
            { id: 1, name: "Malay" },
            { id: 2, name: "Chinese" },
            { id: 3, name: "Indian" },
            { id: 4, name: "Other" },
          ],
        },
        loaded: false,
        chartdata: {
          labels: [
            "Openness To Experience",
            "Conscientiousness",
            "Extraversion",
            "Agreeableness",
            "Neuroticism",
          ],
          datasets: [
            {
              label: "Result",
              backgroundColor: "#F4B656",
              data: [0, 0, 0, 0, 0],
            },
            {
              label: "Local Reference",
              backgroundColor: "#E9668C",
              data: [74, 81, 89, 67, 89],
            },
            {
              label: "Global Reference",
              backgroundColor: "#5EBCD2",
              data: [70, 71, 77, 78, 41],
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
          },
        },
      };
    },
  },
};
</script>
